/* eslint-disable @typescript-eslint/no-unused-vars */
import Drawer from '@mui/material/Drawer'
// import { styled } from '@mui/material/styles'
// import { SwipeableDrawerProps } from '@mui/material/SwipeableDrawer'
import useResponsive from 'src/hooks/useResponsive'
import { drawerWidth, useLayoutContext } from 'src/layouts/layoutContext'
import { useLeftNavTheme } from 'src/context/leftNavThemeContext'

// const StyledDrawer = styled(Drawer)<SwipeableDrawerProps>({
//   overflowX: 'hidden',
//   '& ul': {
//     listStyle: 'none',
//   },
//   '& .MuiListItem-gutters': {
//     paddingLeft: 4,
//     paddingRight: 4,
//   },
// })

const DrawerComponent = (props: { children: React.ReactNode }) => {
  const { navState, setNavHandle } = useLayoutContext()
  const { isMobile } = useResponsive()
  const { leftNavTheme } = useLeftNavTheme()
  const isLightTheme = leftNavTheme === 'light' && !isMobile

  const DesktopDrawerProps = {
    onOpen: () => null,
    onClose: () => setNavHandle?.(),
  }

  return (
    <Drawer
      open={isMobile ? navState : true}
      variant={'persistent'}
      anchor="left"
      {...DesktopDrawerProps}
      PaperProps={{
        sx: {
          borderTopRightRadius: { xs: 0, md: 12 },
          borderBottomRightRadius: { xs: 0, md: 12 },

          width: isMobile ? '100%' : drawerWidth,
          height: '100dvh',
          maxHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: (theme) => theme.zIndex.drawer + 2,
          isolation: 'isolate',
          boxSizing: 'border-box',
          transition:
            'width 200ms, background-color 180ms ease, box-shadow 180ms ease, border-color 180ms ease',

          backgroundColor: isLightTheme
            ? 'rgba(255, 255, 255, 0.72)'
            : 'navigationMenu.background',
          backgroundImage: isLightTheme
            ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.76) 0%, rgba(255, 255, 255, 0.54) 100%)'
            : 'none',
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
          borderRight: isLightTheme
            ? '1px solid rgba(255, 255, 255, 0.72)'
            : (theme) => `${1}px solid ${theme.palette.divider}`,
          boxShadow: isLightTheme
            ? '1px 0 10px rgba(27, 38, 52, 0.045), inset -1px 0 0 rgba(255, 255, 255, 0.54)'
            : 'none',
          overflow: 'hidden',

          ...(isLightTheme
            ? {
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  opacity: 0,
                  pointerEvents: 'none',
                  borderRadius: 'inherit',
                  background:
                    'linear-gradient(112deg, rgba(255, 255, 255, 0.58) 0%, rgba(255, 255, 255, 0.2) 44%, rgba(255, 255, 255, 0.36) 100%)',
                  boxShadow:
                    'inset -1px 0 0 rgba(255, 255, 255, 0.76), inset 1px 0 0 rgba(255, 255, 255, 0.36)',
                  transition: 'opacity 180ms ease',
                  zIndex: 0,
                },
                '& > *': {
                  position: 'relative',
                  zIndex: 1,
                },
                '--left-nav-item-color': '#24323D',
                '--left-nav-item-fill': '#24323D',
                '--left-nav-hover-bg': 'rgba(36, 50, 61, 0.055)',
                '--left-nav-hover-shadow':
                  'inset 0 0 0 1px rgba(36, 50, 61, 0.045)',
                '--left-nav-active-bg':
                  'linear-gradient(135deg, rgba(255, 255, 255, 0.84) 0%, rgba(255, 255, 255, 0.56) 100%)',
                '--left-nav-active-shadow':
                  '0 2px 6px rgba(34, 47, 62, 0.035), inset 0 0 0 1px rgba(11, 214, 141, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.72)',
                '--left-nav-active-color': '#0A7E5B',
                '--left-nav-active-text-color': '#0A7E5B',
                '--left-nav-active-accent': '#0BD68D',
                '--left-nav-section-color': 'rgba(36, 50, 61, 0.58)',
                '--left-nav-subitem-color': '#24323D',
                '--left-nav-subitem-muted-color': 'rgba(36, 50, 61, 0.52)',
                '--left-nav-subitem-hover-color': '#24323D',
                '--left-nav-subitem-hover-bg': 'rgba(36, 50, 61, 0.045)',
                '--left-nav-subitem-hover-shadow': 'none',
                '--left-nav-subitem-active-bg':
                  'linear-gradient(135deg, rgba(255, 255, 255, 0.84) 0%, rgba(255, 255, 255, 0.56) 100%)',
                '--left-nav-subitem-active-shadow':
                  '0 2px 6px rgba(34, 47, 62, 0.03), inset 0 0 0 1px rgba(11, 214, 141, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.7)',
                '--left-nav-subitem-active-color': '#0A7E5B',
                '--left-nav-subitem-active-accent': '#0BD68D',
                '--left-nav-subitem-divider-color': 'rgba(36, 50, 61, 0.08)',
                '--left-nav-subitem-skeleton-bg': 'rgba(36, 50, 61, 0.08)',
              }
            : {}),

          '& .MuiDrawer-paper': {
            width: isMobile ? '100%' : drawerWidth,
            boxSizing: 'border-box',
          },

          '.padding': {
            ml: -3,
            transition: '0.15s',
          },
          '.opacity': {
            opacity: { xs: 1, md: 0 },
            transition: '0.15s',
          },
          '.railLabel': {
            opacity: 1,
            transform: 'translateX(-50%) translateY(0)',
            transition: 'opacity 160ms ease, transform 160ms ease',
          },

          '.disappear': {
            display: isMobile ? 'flex' : 'none',
          },

          '.height': {
            transition: '0.15s',
          },
          '.nav-list-title': {
            color: 'var(--left-nav-section-color)',
          },
          '.nav-section-title .MuiTypography-root, .nav-section-title svg': {
            color: 'var(--left-nav-section-color)',
          },

          pb: 0,

          ...(isMobile
            ? {}
            : {
                '&:hover': {
                  width: 255,
                  ...(isLightTheme
                    ? {
                        backgroundColor: 'rgba(255, 255, 255, 0.18)',
                        backgroundImage:
                          'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.14) 100%)',
                        backdropFilter: 'blur(14px) saturate(140%)',
                        WebkitBackdropFilter: 'blur(14px) saturate(140%)',
                        borderRight: '1px solid rgba(255, 255, 255, 0.62)',
                        boxShadow:
                          '4px 0 16px rgba(27, 38, 52, 0.075), inset -1px 0 0 rgba(255, 255, 255, 0.48)',
                        '&::before': {
                          opacity: 0.22,
                        },
                      }
                    : {}),

                  '.railLabel': {
                    opacity: 0,
                    transform: 'translateX(-50%) translateY(-4px)',
                  },

                  '.disappear': {
                    display: 'flex',
                  },

                  '.height': {
                    height: 'auto !important',
                  },

                  '.opacity': {
                    opacity: 1,
                  },

                  '.padding': {
                    ml: 0,
                  },
                },
              }),
        },
      }}
    >
      {props.children}
    </Drawer>
  )
}

// fill 200ms cubic-bezier(0.4, 0, 0.2, 1);

export default DrawerComponent

// '.navIcon': {
//   width: '20%',
// },
// '.navItemsSchemaShowMore': {
//   height: '30px',
// },
// '.navText': {
//   width: '80%',
//   ml: 2,
// },
// '.navItemCollapse': {
//   maxHeight: 'none',
//   opacity: 1,

//   display: 'block',
// },

/// HOVER

// '.navItemCollapse': {
//   // display:'none',
//   overflow: 'hidden',
//   opacity: 0,
//   maxHeight: '0px',
//   transition: 'opacity 0.2s ease-in-out',
//   transitionDelay: '0.2s',
// },
// '.navIcon': {
//   width: '100%',
// },

// '.navText': {
//   width: 0,
// },
// '.navItemsSchemaShowMore': {
//   height: '0px',
// },
